export default {
  data() {
    return {
      items: [],
      activeId: null,
      isOpenView: false,
      isOpenRemove: false,
      isOpenEditing: false,
      isOpenCreation: false
    };
  },
  methods: {
    openView(id) {
      this.isOpenView = true;
      this.activeId = id;
    },
    closeView() {
      this.isOpenView = false;
      this.activeId = null;
    },
    openCreation() {
      this.isOpenCreation = true;
    },
    closeCreation() {
      this.isOpenCreation = false;
    },
    openEditing(id) {
      this.isOpenEditing = true;
      this.activeId = id;
    },
    closeEditing() {
      this.isOpenEditing = false;
      this.activeId = null;
    },
    openRemoving(id) {
      this.isOpenRemove = true;
      this.activeId = id;
    },
    closeRemoving() {
      this.isOpenRemove = false;
      this.activeId = null;
    },
    afterAction() {
      if (typeof this.redirectTo === "function") {
        this.redirectTo();
      }
    },
    async remove(id, async = false) {
      const fn = this.$store.dispatch(this.removeAction(), { id });
      if (async) {
        await fn;
      }
      fn.then(() => {
        this.removed();
      });
    },
    failed(response) {
      const message =
        response && response.message
          ? response.message
          : this.$lang("main.crud.something_went_wrong");
      this.showNotification(message, "error");
    },
    created(response) {
      this.afterAction();
      this.closeCreation();
      this.showNotification(this.$lang("main.crud.success_create"), "success");
    },
    updated(response) {
      this.afterAction();
      this.closeEditing();
      this.showNotification(this.$lang("main.crud.success_update"), "success");
    },
    removed(response) {
      this.afterAction();
      this.closeRemoving();
      this.showNotification(this.$lang("main.crud.success_remove"), "success");
    }
  }
};
